import Component from './panel.vue';
export default Component;
